export default class Land {
	constructor() {
		this.id = null
		this.title = null
		this.localeKey = null
		this.regions = []
		this.grapeVarieties = []
	}
}